import LabServiceCollection from "@/collections/LabServiceCollection";
import JigModel from "@/models/lab/JigModel";

export default class JigCollection extends LabServiceCollection {
  model() {
    return JigModel;
  }

}
